import React from "react";
import { toast } from "react-toastify";
import Layout4 from "../../components/Layout/Layout4";
import Loading from "../../components/Loading";
import DispatchTable from "../../components/dispatchTable";
import { completeChallanWithImageApi, getAllDispatch } from "../../utils/api";
import useStore from "../../utils/store";

const Dispatch = () => {
  const [dash, setDash] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dispatchNote, setDispatchNote] = React.useState("");

  const getData = async () => {
    setLoading(true);
    const [success, data] = await getAllDispatch();
    if (success) {
      setDash(data);
    }
    setLoading(false);
  };

  const user = useStore((state) => state.user);

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <Layout4 type={"Dispatch"} title={user?.staff?.userName}>
      {loading && <Loading />}
      <DispatchTable
        type="dispatch"
        data={dash}
        dispatchNote={dispatchNote}
        setDispatchNote={setDispatchNote}
        complete={async (ids, note, photoFile) => {
          setLoading(true);
          try {
            const formData = new FormData();
            formData.append("ids", JSON.stringify(ids));
            formData.append("type", "staff");
            formData.append("completedById", user?.staff?._id || user?._id || "");
            formData.append("dispatchNote", note || dispatchNote || "");
            if (photoFile) {
              formData.append("image", photoFile);
            }

            const [success, data] = await completeChallanWithImageApi(formData);
            if (success) {
              toast.success("✅ Dispatch Completed & Photo Attached!");
              getData();
              setDispatchNote("");
            } else {
              toast.error(data || "Failed to complete dispatch");
            }
          } catch (err) {
            console.error(err);
            toast.error("Error completing dispatch");
          } finally {
            setLoading(false);
          }
        }}
        refresh={getData}
      />
    </Layout4>
  );
};

export default Dispatch;
